/**
 * Import des styles
 * ****************************************
 */
import "./sass/main.scss";

/**
 * Import des modules
 * ****************************************
 */

import RecipesFilters from "./ts/RecipesFilters";
import Menu from "./ts/Menu";
import VideoPopups from "./ts/VideoPopups";
import Images from "./ts/sliders/Images";
import RelatedContent from "./ts/sliders/RelatedContent";
import Home from "./ts/sliders/Home";
import Filters from "./ts/Filters";
import OnScroll from "./ts/OnScroll";

import ScrollTriger from "./ts/ScrollTrigger";

/**
 * Initialisation des modules
 * ******************************
 */
window.onload = () => {
	/**
	 * Initialisation de scrollTrigger
	 * ******************************
	 */
	setTimeout(() => ScrollTriger(), 50)


	/**
	 * Gestion des filtres de la page "recettes"
	 * ******************************
	 */
	RecipesFilters();

	/**
	 * Gestion des sous-menus
	 * ******************************
	 */
	Menu();

	/**
	 * Gestion des popups "video"
	 * ******************************
	 */
	VideoPopups();

	/**
	 * Gestion du sliders d'images
	 * ******************************
	 */
	Images();

	/**
	 * Gestion des sliders "contenu connexe"
	 * ******************************
	 */
	RelatedContent();

	/**
	 * Gestion des sliders Home
	 * ******************************
	 */
	Home();

	/**
	 * Gestion des filtres
	 * ******************************
	 */
	Filters();

	/**
	 * Gestion des filtres
	 * ******************************
	 */
	OnScroll();
};
